import { use_slice_generation, use_slice_grid2d } from '@/hooks/store/use_slices';
import { GRID2D__float } from '@/pages/_base/grid2d/views/GRID2D__float';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useMemo } from 'react';
import { GRID2D__loading } from '../views/GRID2D__loading';

interface PROPS {
  entity_id: string;
}

//todo:load from server and remove this component
export function GRID2D__user_task({ entity_id }: PROPS) {
  const { user_tasks_map } = use_slice_generation(['user_task_current', 'user_tasks_map']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  const user_task = useMemo(() => get_user_task(), [user_tasks_map, entity_id]);
  const grid2d = useMemo(() => get_grid2d(), [user_task, grids2d_map]);

  /*
   * METHODS
   */
  function get_user_task() {
    if (!user_tasks_map.has(entity_id)) return DTO__user_task.CREATE_STUB();

    let out = user_tasks_map.get_or_assert(entity_id);

    return out;
  }

  function get_grid2d() {
    let out = new DTO__grid2d();
    [out.workspace_id, out._id, out.entity_type] = [user_task.workspace_id, user_task._id, user_task.type];

    let out_chunk = new DTO__grid2d_chunk();
    [out_chunk.workspace_id, out_chunk._id, out_chunk.entity_type] = [user_task.workspace_id, user_task._id, user_task.type];

    let cells: DTO__grid2d_cell[] = [];

    for (let generation of user_task.generations) {
      if (!grids2d_map.has(generation._id)) continue;

      let grid2d = grids2d_map.get_or_assert(generation._id);

      let cells_loaded = grid2d.cells__get_loaded();

      cells = [...cells, ...cells_loaded];
    }

    cells = cells.filter(cell => !cell.hash_sha256_content.is_empty_hash_sha256()); //keep only with content
    cells = cells.map(cell => cell.clone());

    /*
     * UNIQUE
     */

    let hashes_set = new Set();

    let cells_unique = [];

    for (let cell of cells) {
      if (hashes_set.has(cell.hash_sha256_content)) continue;

      cells_unique.push(cell);

      hashes_set.add(cell.hash_sha256_content);
    }

    /*
     *
     */

    out_chunk.cells_list = cells_unique;
    out_chunk.are_cells_loaded_first_time = true;
    [out_chunk.cells_amount, out_chunk.images_amount] = [cells_unique.length, cells_unique.length];

    out.chunk__upsert(out_chunk);

    return out;
  }

  /*
   * RENDERS
   */
  function render_grid() {
    if (grid2d.is_stub()) return <GRID2D__loading entity={user_task} />;
    if (user_task.is_stub()) return <GRID2D__loading entity={user_task} />;

    return <GRID2D__float grid2d={grid2d} entity={user_task} />;
  }

  /*
   * HTML
   */
  //todo:use
  /* <WatcherGetGrid2dUserTaskCurrentImages /> */
  return (
    <>
      <div className="size-full bg-component">{render_grid()}</div>
    </>
  );
}
